module.exports = __webpack_public_path__ + "media/images/lb/269-fd033f9f020c6a539a49ba02c7258fc3.svg";